import { render, staticRenderFns } from "./EditarPromocao.vue?vue&type=template&id=7b210f34&"
import script from "./EditarPromocao.vue?vue&type=script&lang=js&"
export * from "./EditarPromocao.vue?vue&type=script&lang=js&"
import style0 from "./EditarPromocao.vue?vue&type=style&index=0&id=7b210f34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports